import { Question } from '.';

export class QuestionLogicResolverData {
    questionSet: Question[];
    questionType: string;
    forwardNavRoute: string;
    backwardNavRoute: string;
    backwardNavIcon: string;  
}
